import { LANGUAGE_CN } from '@home/_config/config';

/**
 * 数据源名称列表（用于展示数据源图标和标题）
 */
export const DATASOURCE_EXPLANATION_HTML_DATASOURCE_LIST = ['MScience', 'NPD', 'GSD'];

/**
 * @author: lv.chen
 * @date: 2025/1/14
 * @desc: 数据源差异解释HTML格式配置
 *
 * 优化方案：将原本拆分成多个key的文案合并为完整HTML格式
 * - 每个数据源一个完整的HTML文案
 * - 使用 <span class="yellow-highlight"> 标记需要高亮的内容
 * - 易于理解和维护，修改时无需多处同步
 */

/**
 * 中文HTML配置
 */
const ZH_CN_HTML_CONTENT: IRecord<string> = {
  MScience: `提供PC/Console游戏的<span class="yellow-highlight">Digital Revenue</span>，仅限<span class="yellow-highlight">美、英、法、德、西</span>，有日/月粒度数据`,

  NPD: `提供PC/Console游戏的<span class="yellow-highlight">Physical Revenue</span>，仅<span class="yellow-highlight">美国</span>，仅<span class="yellow-highlight">月</span>度数据`,

  GSD: `提供PC/Console游戏的<span class="yellow-highlight">Digital & Physical Revenue</span>，主要覆盖<span class="yellow-highlight">欧美及部分亚洲国家</span>，仅<span class="yellow-highlight">周</span>数据`,
};

/**
 * 英文HTML配置
 */
const EN_US_HTML_CONTENT: IRecord<string> = {
  MScience: `Provides <span class="yellow-highlight">digital revenue</span> for PC/Console games, <span class="yellow-highlight">US, UK, France, Germany, and Spain</span> data only, with daily/monthly granularity.`,

  NPD: `Provides <span class="yellow-highlight">physical revenue</span> for PC/Console games, <span class="yellow-highlight">United States</span> data only, with <span class="yellow-highlight">monthly</span> granularity only.`,

  GSD: `Provides <span class="yellow-highlight">digital and physical revenue</span> data for PC/Console games. Data coverage primarily includes <span class="yellow-highlight">Europe, North America, and parts of Asia</span>, with <span class="yellow-highlight">weekly</span> granularity only.`,
};

/**
 * 获取HTML格式的数据源解释内容
 * @param locale 语言环境 'zh-CN' | 'en-US'
 * @returns 数据源HTML内容映射
 */
export const getDataSourceExplanationHtmlContent = (locale: string): IRecord<string> => {
  return locale === LANGUAGE_CN ? ZH_CN_HTML_CONTENT : EN_US_HTML_CONTENT;
};
